// import React, { useState } from 'react'
// import backImage from '@/assets/images/newBG.png'
// import bg from '@/assets/images/bg-theme.png';
// import { Button, Card, Form, Input, message } from 'antd'
// import { LockFilled, UserOutlined } from '@ant-design/icons'
// import { MdPassword } from 'react-icons/md'
// import './NewLoginPage.css';
// import { Link, useNavigate } from 'react-router'
// import person from '@/assets/images/personbg.png'
// import logo from '@/assets/images/vantageAI.png'
// import axios from 'axios';
// import { useUserActions } from '@/store/userStore';

// const NewLoginPage = () => {

//  	const { VITE_APP_URL: URL } = import.meta.env;
//   const navigate = useNavigate();
//   const {  setUserInfo } = useUserActions();

//   const [ email , setEmail ] = useState("");
//   const [ password , setPassword ] = useState("");
//   const [ loading , setLoading ] = useState<boolean>(false);

//   // Login Function
//   const handleLogin = async() =>{
//     setLoading(true);
//     try{
//       	const response = await axios.post(`${URL}/api/users/login`, {
// 				  email: email,
// 				  password: password,
// 			  });
//         localStorage.setItem("roleId", response.data?.role_id);
// 			  localStorage.setItem("userId", response.data?.user_info.user_id);
// 			  localStorage.setItem("departmentName", response.data?.user_info.department);
// 			  setUserInfo(response.data?.user_info);
//         // sessionStorage.setItem("needsPostLoginRefresh", "true");
//         message.success("Login successfull")
// 			  navigate("/dashboard/dashboard-playgrounds", { replace: true });
//     }catch(err){
//         if(err.response){
//           const error = err.response.data?.error;
//           message.error(error || "Something went wrong")
//         }else{
//           message.error("Network error. Please try again")
//         }
//     }finally{
//       setLoading(false);
//     }
//   }


//   return (
//     <div className='login-page w-screen h-screen bg-cover bg-center bg-no-repeat flex items-center relative'>

//       <div className='absolute left-0 top-0 w-full flex'>
//         <img src={bg} alt="" className="img1"/>
//         <img src={person} alt="" className="img2"/>
//       </div>

//       <div className="linear-box"></div>
//       <div className="linear-box"></div>

//       <div className='w-1/2 flex flex-col items-center justify-center z-20'>
//           <img src={logo} alt="logo"  className='w-[200px] h-[40px]'/>
//           <div style={{width: "70%" ,backgroundColor:"#171924",marginTop:"70px" ,borderColor:"#23252f"}}  className='px-6 py-4 rounded-md border'>
//             <div className='flex flex-col gap-2 p-6 px-6 border-b border-[#23252f] -mx-6'>
//               <div className='flex items-center gap-4'>
//                 <LockFilled className='text-gray-600'/>
//                 <span className='text-2xl font-medium tracking-[0.2px] text-common-white'>Login to Vantage AI</span>
//               </div>
//               <span className='text-gray-600'>Sign in to your account to continue</span>
//             </div>
//             <div className='flex flex-col gap-y-2 mt-10 dark-form-item'>
//                 <Form.Item label={<span className='text-[18px] text-common-white'>Email</span>} layout='vertical' >
//                     <Input
//                       style={{height: 40, backgroundColor: "#212432",borderColor:"#373b45"}}
//                       placeholder='Example: example@gmail.com'
//                       prefix={<UserOutlined style={{color:"#dedee0"}}/>}
//                       value={email}
//                       onChange={(e)=>setEmail(e.target.value)}
//                       className="dark-input"
//                     />
//                 </Form.Item>
//                 <Form.Item label={<span className='text-[18px] text-common-white'>Password</span>} className='dark-input-scope' layout='vertical'>
//                     <Input.Password
//                       style={{height: 40, backgroundColor: "#212432",borderColor:"#373b45" }}
//                       className='dark-password'
//                       value={password}
//                       onChange={(e)=>setPassword(e.target.value)}
//                     />
//                     <div className=' w-full  flex justify-end'>
//                       <span className='text-sm text-[#5a65dd] font-medium cursor-pointer hover:text-white mt-4'>Forgot Password?</span>
//                     </div>
//                 </Form.Item>
//                 <Button type='primary' size='large' onClick={handleLogin} loading={loading} >Login</Button>
//             </div>

//           </div>
//           <span className='mt-6 font-medium text-lg select-none text-common-white'>Want to register as client?  <Link to={"/register-client"}> Register</Link></span>
//           <span className='mt-6 text-[#646775] select-none'>&copy; 2025 Vantage AI. All rights reserved.</span>
//       </div>
//     </div>
//   )
// }

// export default NewLoginPage

import React, { useState } from 'react'
import loginBackground from '@/assets/images/login_background.png'
import valiantlytixLogo from '@/assets/images/darkLogo.png'
import { Button, Card, Form, Input, message, Divider } from 'antd'
import { LockFilled, UserOutlined, EyeInvisibleOutlined, EyeTwoTone, KeyOutlined } from '@ant-design/icons'
import { MdPassword, MdOutlineRocketLaunch } from 'react-icons/md'
import './NewLoginPage.css';
import { Link, useNavigate, useLocation } from 'react-router-dom'
import logo from '@/assets/images/vantageAI.png'
import axios from 'axios';
import useUserStore, { useUserActions } from '@/store/userStore';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '@/firebase';
import { useNotificationStore } from '@/store/notificationStore';
import AuthErrorModal from '@/components/AuthErrorModal';

const NewLoginPage = () => {

  const { VITE_APP_URL: URL } = import.meta.env;
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserInfo, setCreditsRemaining, setTotalCreditsAllocated, setDaysRemaining, setTier, setTierId, setFeatureAccess, refreshCredits } = useUserActions();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState<boolean>(false);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errorTitle, setErrorTitle] = useState<string>("Sign In Failed");
  const [errorCallback, setErrorCallback] = useState<(() => void) | null>(null);

  // Login Function
  const handleLogin = async () => {
    if (!email || !password) {
      setErrorTitle("Missing Information");
      setErrorMessage("Please enter both your email and password.");
      setErrorCallback(null);
      return;
    }

    setLoading(true);
    try {

      // const userCredentials = await signInWithEmailAndPassword(auth, email, password)

      const response = await axios.post(`${URL}/api/users/login`, {
        email: email,
        password: password,
      });

      // const  response = await axios.get(`${URL}/api/users/get-user-fuid/${userCredentials.user.uid}`)
      const userId = response.data?.user_info?.user_id || response.data?.user_info?.id;

      // Clean up previous transient payment and store state
      localStorage.removeItem("pending_payment");
      sessionStorage.removeItem("active_transaction_id");
      try {
        useNotificationStore.getState().actions.clearNotifications();
      } catch (e) {}

      localStorage.setItem("roleId", response.data?.role_id);
      localStorage.setItem("userId", userId);
      localStorage.setItem("departmentName", response.data?.user_info?.department);
      
      setCreditsRemaining(null);
      setTotalCreditsAllocated(null);
      setDaysRemaining(null);
      setFeatureAccess({});
      setTier(response.data?.user_info?.tier || null);
      setTierId(response.data?.user_info?.tier_id || null);
      setUserInfo(response.data?.user_info);

      const { addNotification } = useNotificationStore.getState().actions;
      const userInfo = response.data?.user_info;

      // Login notification
      addNotification({
        type: 'system',
        title: 'Login Successful',
        message: `Welcome back, ${userInfo?.name || email}! You have logged in successfully.`,
      });

      // Fetch credits & trial days after login
      try {
        if (userId) {
          await refreshCredits();
          const state = useUserStore.getState();
          const credits = state.creditsRemaining;
          const days = state.daysRemaining;

          if (credits !== null && credits !== undefined) {
            if (credits <= 0) {
              addNotification({ type: 'credits', title: 'Credits Exhausted', message: 'You have 0 credits remaining. Please upgrade your plan to continue.' });
            } else if (credits <= 5) {
              addNotification({ type: 'credits', title: 'Low Credits Warning', message: `You have only ${credits} credit${credits === 1 ? '' : 's'} remaining. Consider upgrading your plan.` });
            } else {
              addNotification({ type: 'credits', title: 'Credits Available', message: `You have ${credits} credit${credits === 1 ? '' : 's'} remaining.` });
            }
          }

          if (days !== null) {
            if (days <= 0) {
              addNotification({ type: 'trial', title: 'Trial Expired', message: 'Your trial period has ended. Please upgrade to keep access.' });
            } else if (days <= 3) {
              addNotification({ type: 'trial', title: 'Trial Ending Soon', message: `Your trial expires in ${days} day${days === 1 ? '' : 's'}. Upgrade now to avoid interruption.` });
            } else {
              addNotification({ type: 'trial', title: 'Trial Active', message: `You have ${days} day${days === 1 ? '' : 's'} remaining in your trial.` });
            }
          }
        }
      } catch (creditsErr) {
        console.error('Failed to fetch credits after login:', creditsErr);
      }

      // sessionStorage.setItem("needsPostLoginRefresh", "true");
      message.success("Login successfull")
      
      // Initialize enterprise credit
      try {
        await axios.post(`${URL}/api/payments/stripe/initialize-enterprise-credit`, {
          user_id: userId
        });
      } catch (creditErr) {
        console.error('Failed to initialize enterprise credit:', creditErr);
      }

      const queryParams = new URLSearchParams(location.search);
      const returnUrl = queryParams.get("returnUrl");
      const redirectUrl = returnUrl ? decodeURIComponent(returnUrl) : "/dashboard/home";
      navigate(redirectUrl, { replace: true });
    } catch (err: any) {
      if (err.response) {
        const error = err.response.data?.error || err.response.data?.message || "Something went wrong";
        setErrorTitle("Sign In Failed");
        setErrorMessage(error);
        if (error === "Email not verified. Verification email has been resent." || error === "Verification email already sent. Please check your inbox.") {
          setErrorCallback(() => () => navigate("/verify-user-email", { state: { email } }));
        } else {
          setErrorCallback(null);
        }
      } else {
        setErrorTitle("Connection Error");
        setErrorMessage("Network error. Please check your connection and try again.");
        setErrorCallback(null);
      }
    } finally {
      setLoading(false);
    }
  }


  return (
    <div className='flex w-full h-screen bg-[#F8F9FA] font-sans'>
      {/* Left side: Form Panel */}
      <div className='w-full lg:w-1/2 h-full flex flex-col items-center relative px-4 sm:px-8 overflow-y-auto'>
        
        <div className='w-full max-w-[440px] flex flex-col items-center my-auto py-8'>
          {/* Logo at Top */}
          <div className='w-full flex justify-center mb-8'>
            <img src={logo} alt="Vantage AI Logo" className='w-[160px] md:w-[200px] h-auto object-contain' />
          </div>

          {/* Form Container */}
          <div className='w-full bg-white px-6 sm:px-8 py-8 sm:py-10 rounded-2xl shadow-sm border border-gray-100 flex flex-col'>
            <div className='flex flex-col gap-2 mb-6'>
              <div className='flex items-center gap-3'>
             <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.56888 17.85C1.13546 17.85 0.765625 17.6958 0.459375 17.3873C0.153125 17.0789 0 16.7081 0 16.275V7.875C0 7.44187 0.154219 7.07109 0.462656 6.76266C0.771094 6.45422 1.14188 6.3 1.575 6.3H2.1V4.2C2.1 3.038 2.51001 2.0475 3.33003 1.2285C4.14991 0.409499 5.14157 0 6.30503 0C7.46834 0 8.45833 0.409499 9.275 1.2285C10.0917 2.0475 10.5 3.038 10.5 4.2V6.3H11.025C11.4581 6.3 11.8289 6.45422 12.1373 6.76266C12.4458 7.07109 12.6 7.44187 12.6 7.875V16.275C12.6 16.7081 12.4457 17.0789 12.1371 17.3873C11.8285 17.6958 11.4575 17.85 11.0241 17.85H1.56888ZM1.575 16.275H11.025V7.875H1.575V16.275ZM6.30459 13.65C6.73903 13.65 7.10938 13.4953 7.41563 13.186C7.72188 12.8767 7.875 12.5048 7.875 12.0704C7.875 11.636 7.72034 11.2656 7.41103 10.9594C7.10172 10.6531 6.72984 10.5 6.29541 10.5C5.86097 10.5 5.49063 10.6547 5.18438 10.964C4.87813 11.2733 4.725 11.6452 4.725 12.0796C4.725 12.514 4.87966 12.8844 5.18897 13.1906C5.49828 13.4969 5.87016 13.65 6.30459 13.65ZM3.675 6.3H8.925V4.2C8.925 3.47083 8.66979 2.85104 8.15938 2.34063C7.64896 1.83021 7.02917 1.575 6.3 1.575C5.57083 1.575 4.95104 1.83021 4.44063 2.34063C3.93021 2.85104 3.675 3.47083 3.675 4.2V6.3Z" fill="#A51C1C"/>
</svg>

                <span className='text-xl md:text-2xl font-semibold tracking-[0.2px] text-gray-900'>Sign In to Vantage AI</span>
              </div>
              <span className='text-gray-500 text-sm'>Sign in to your account to continue</span>
            </div>

            <div className='flex flex-col gap-y-4'>
              <Form.Item label={<span className='text-sm font-medium text-gray-700 mb-1 block'>Email</span>} className='mb-0' layout='vertical'>
                <Input
                  size="large"
                  style={{ backgroundColor: "#F8F9FA", borderColor: "#E5E7EB", height: 48 }}
                  placeholder='example@gmail.com'
                  prefix={<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.7 5.7C4.90833 5.7 4.23542 5.42292 3.68125 4.86875C3.12708 4.31458 2.85 3.64167 2.85 2.85C2.85 2.05833 3.12708 1.38542 3.68125 0.83125C4.23542 0.277083 4.90833 0 5.7 0C6.49167 0 7.16458 0.277083 7.71875 0.83125C8.27292 1.38542 8.55 2.05833 8.55 2.85C8.55 3.64167 8.27292 4.31458 7.71875 4.86875C7.16458 5.42292 6.49167 5.7 5.7 5.7ZM0 11.4V9.5C0 9.19653 0.0824653 8.90955 0.247396 8.63906C0.412326 8.36858 0.639931 8.14097 0.930208 7.95625C1.6559 7.53403 2.42309 7.21076 3.23178 6.98646C4.04047 6.76215 4.86182 6.65 5.69584 6.65C6.52986 6.65 7.3526 6.76215 8.16406 6.98646C8.97552 7.21076 9.7441 7.53403 10.4698 7.95625C10.7601 8.12778 10.9877 8.35208 11.1526 8.62917C11.3175 8.90625 11.4 9.19653 11.4 9.5V11.4H0ZM1.425 9.975H9.975V9.5C9.975 9.43165 9.95501 9.36957 9.91503 9.31376C9.87518 9.25782 9.8226 9.21434 9.75729 9.18333C9.15035 8.81389 8.50382 8.53681 7.81771 8.35208C7.1316 8.16736 6.42569 8.075 5.7 8.075C4.97431 8.075 4.2684 8.16736 3.58229 8.35208C2.89618 8.53681 2.24965 8.81389 1.64271 9.18333C1.57674 9.23611 1.52396 9.28704 1.48438 9.33613C1.44479 9.38534 1.425 9.43997 1.425 9.5V9.975ZM5.70416 4.275C6.09722 4.275 6.43229 4.13507 6.70937 3.85522C6.98646 3.57536 7.125 3.23891 7.125 2.84584C7.125 2.45278 6.98507 2.11771 6.70522 1.84062C6.42536 1.56354 6.08891 1.425 5.69584 1.425C5.30278 1.425 4.96771 1.56493 4.69062 1.84478C4.41354 2.12464 4.275 2.46109 4.275 2.85416C4.275 3.24722 4.41493 3.58229 4.69478 3.85938C4.97464 4.13646 5.31109 4.275 5.70416 4.275Z" fill="#9AA1AD"/>
</svg>
}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="light-input rounded-lg hover:border-gray-300 focus:border-[#A91D22]"
                />
              </Form.Item>

              <Form.Item label={<span className='text-sm font-medium text-gray-700 mb-1 block'>Password</span>} className='mb-0' layout='vertical'>
                <Input.Password
                  size="large"
                  style={{ backgroundColor: "#F8F9FA", borderColor: "#E5E7EB", height: 48 }}
                  className='light-password rounded-lg hover:border-gray-300 focus:border-[#A91D22]'
                  placeholder='Enter your password'
                  prefix={<svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.75 6.65C4.22222 6.65 3.77361 6.46528 3.40417 6.09583C3.03472 5.72639 2.85 5.27778 2.85 4.75C2.85 4.22222 3.03472 3.77361 3.40417 3.40417C3.77361 3.03472 4.22222 2.85 4.75 2.85C5.27778 2.85 5.72639 3.03472 6.09583 3.40417C6.46528 3.77361 6.65 4.22222 6.65 4.75C6.65 5.27778 6.46528 5.72639 6.09583 6.09583C5.72639 6.46528 5.27778 6.65 4.75 6.65ZM4.75 9.5C3.43056 9.5 2.30903 9.03819 1.38542 8.11458C0.461806 7.19097 0 6.06944 0 4.75C0 3.43056 0.461806 2.30903 1.38542 1.38542C2.30903 0.461806 3.43056 0 4.75 0C5.60764 0 6.39931 0.21441 7.125 0.643229C7.85069 1.07205 8.43125 1.64931 8.86667 2.375H15.675L18.05 4.75L14.4875 8.075L12.825 6.8875L11.4 8.075L9.5 6.65H9.10417C8.7875 7.54722 8.22344 8.24653 7.41198 8.74792C6.60052 9.24931 5.71319 9.5 4.75 9.5ZM4.75 8.075C5.58125 8.075 6.31354 7.80781 6.94688 7.27344C7.58021 6.73906 7.94306 6.05625 8.03542 5.225H9.975L11.3604 6.25417L12.7656 5.08646L14.3687 6.23438L15.9917 4.73021L15.0813 3.8H7.93646C7.68576 3.10069 7.27344 2.53003 6.69948 2.08802C6.12552 1.64601 5.47569 1.425 4.75 1.425C3.82639 1.425 3.04132 1.74826 2.39479 2.39479C1.74826 3.04132 1.425 3.82639 1.425 4.75C1.425 5.67361 1.74826 6.45868 2.39479 7.10521C3.04132 7.75174 3.82639 8.075 4.75 8.075Z" fill="#9AA1AD"/>
</svg>
}
                  iconRender={(visible) => (visible ? <EyeTwoTone twoToneColor="#A91D22" /> : <EyeInvisibleOutlined className="text-gray-400" />)}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className='w-full flex justify-end mt-2'>
                  <span className='text-sm text-[#A91D22] font-normal cursor-pointer hover:text-[#8a171b] transition-colors' onClick={() => navigate("/reset-password")}>Forgot Password?</span>
                </div>
              </Form.Item>

              <Button type='primary' size='large' onClick={handleLogin} loading={loading} className='w-full h-12 mt-4 text-base font-medium !bg-[#A91D22] hover:!bg-[#8a171b] !border-none rounded-lg shadow-md transition-all flex items-center justify-center'>
                Sign in
              </Button>
            </div>

            <div className="flex items-center my-6">
              <div className="flex-grow border-t border-gray-200"></div>
              <span className="flex-shrink-0 mx-4 text-gray-400 text-[13px]">New to VantageAI?</span>
              <div className="flex-grow border-t border-gray-200"></div>
            </div>

            <Button 
              size='large' 
              onClick={() => navigate("/sign-up-user")} 
              className='w-full h-12 text-base font-medium !text-[#A91D22] border !border-[#A91D22] !bg-[#fdf2f2] hover:!bg-[#fce4e4] rounded-lg transition-all flex items-center justify-center gap-2'
            >
              <MdOutlineRocketLaunch className="text-lg" />
              Sign Up
            </Button>
          </div>
        </div>

        <span className='text-gray-400 text-xs md:text-sm select-none pb-6 mt-auto'>&copy; 2026 Vantage AI. All rights reserved.</span>
      </div>

      {/* Right side: Image Panel */}
      <div className='hidden lg:flex w-1/2 relative bg-black items-center justify-center overflow-hidden'>
        <img src={loginBackground} alt="Vantage AI Dashboard Graphic" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        
        <div className="absolute top-16 left-16 z-10">
          <div className="text-white text-[42px] leading-[1.2] font-bold tracking-tight">
            <div>Turn raw data into</div>
            <div>professional <span className="text-[#FCA5A5]">Dashboards</span></div>
            <div>in minutes.</div>
          </div>
        </div>

        {/* Valiantlytix Logo Overlay */}
        <div className="absolute bottom-12 right-12 z-10">
          <img src={valiantlytixLogo} alt="Valiantlytix Logo" className="w-[180px] h-auto object-contain" />
        </div>
      </div>

      {/* Error Modal */}
      <AuthErrorModal
        open={!!errorMessage}
        onClose={() => {
          setErrorMessage(null);
          setErrorCallback(null);
        }}
        title={errorTitle}
        message={errorMessage || ""}
        onOk={errorCallback || undefined}
      />
    </div>
  )
}

export default NewLoginPage